/* Calculadora de frete na página de produto (bloco "Prazo, frete e destaques").
   A Shopify só calcula frete de itens na sacola: a peça escolhida entra na sacola
   por um instante, o frete é consultado e a sacola volta ao que era. */
(function () {
  var UF = {
    AC: 'Acre', AL: 'Alagoas', AP: 'Amapa', AM: 'Amazonas', BA: 'Bahia', CE: 'Ceara',
    DF: 'Distrito Federal', ES: 'Espirito Santo', GO: 'Goias', MA: 'Maranhao',
    MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais', PA: 'Para',
    PB: 'Paraiba', PR: 'Parana', PE: 'Pernambuco', PI: 'Piaui', RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul', RO: 'Rondonia', RR: 'Roraima',
    SC: 'Santa Catarina', SP: 'Sao Paulo', SE: 'Sergipe', TO: 'Tocantins'
  };

  function money(value) {
    var n = parseFloat(value);
    if (isNaN(n)) return '';
    return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function jsonFetch(url, options) {
    return fetch(url, options).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var err = new Error((data && (data.description || data.message)) || 'erro');
          err.status = r.status;
          throw err;
        }
        return data;
      });
    });
  }

  function post(url, body) {
    return jsonFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function currentVariantId(root) {
    var scope = root.closest('.productView') || document;
    var field = scope.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]');
    return (field && field.value) || root.getAttribute('data-variant-id');
  }

  function getRates(cep) {
    return jsonFetch('https://viacep.com.br/ws/' + cep + '/json/').then(function (addr) {
      if (addr.erro) throw new Error('cep');
      var params = 'shipping_address%5Bzip%5D=' + cep +
        '&shipping_address%5Bcountry%5D=Brazil' +
        '&shipping_address%5Bprovince%5D=' + encodeURIComponent(UF[addr.uf] || addr.uf);
      return jsonFetch('/cart/shipping_rates.json?' + params);
    });
  }

  function deliveryText(rate) {
    var d = rate.delivery_days || [];
    var max = d[1] || d[0];
    if (!max) return '';
    return 'até ' + max + (max > 1 ? ' dias úteis' : ' dia útil');
  }

  function render(list, rates) {
    list.innerHTML = '';
    rates.forEach(function (rate) {
      var li = document.createElement('li');
      li.className = 'ptd__rate';
      var price = parseFloat(rate.price) === 0 ? 'Grátis' : money(rate.price);
      var days = deliveryText(rate);
      li.innerHTML = '<span class="ptd__rate-name"></span><span class="ptd__rate-price"></span>';
      li.querySelector('.ptd__rate-name').textContent = rate.name + (days ? ' - ' + days : '');
      li.querySelector('.ptd__rate-price').textContent = price;
      list.appendChild(li);
    });
  }

  function calculate(root) {
    var input = root.querySelector('.ptd__cep');
    var button = root.querySelector('.ptd__calc');
    var list = root.querySelector('.ptd__rates');
    var msg = root.querySelector('.ptd__msg');
    var cep = (input.value || '').replace(/\D/g, '');

    msg.textContent = '';
    list.innerHTML = '';
    if (!/^[0-9]{8}$/.test(cep)) {
      msg.textContent = 'Digite um CEP válido com 8 números.';
      return;
    }

    var variantId = currentVariantId(root);
    if (!variantId) {
      msg.textContent = 'Escolha a cor e o tamanho para calcular.';
      return;
    }

    button.disabled = true;
    button.classList.add('is-loading');

    var qtyBefore = 0;
    var lineKey = null;

    jsonFetch('/cart.js')
      .then(function (cart) {
        cart.items.forEach(function (item) {
          if (String(item.variant_id) === String(variantId)) qtyBefore += item.quantity;
        });
        return post('/cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] });
      })
      .then(function (added) {
        var item = added && added.items ? added.items[0] : added;
        lineKey = item && item.key;
        return getRates(cep);
      })
      .then(function (data) {
        var rates = (data && data.shipping_rates) || [];
        if (!rates.length) {
          msg.textContent = 'Não encontramos opções de entrega para este CEP.';
        } else {
          render(list, rates);
        }
      })
      .catch(function (err) {
        if (err && err.message === 'cep') {
          msg.textContent = 'CEP não encontrado. Confira e tente de novo.';
        } else if (err && err.status === 422 && !lineKey) {
          msg.textContent = 'Esta opção está sem estoque. Escolha outra cor ou tamanho.';
        } else {
          msg.textContent = 'Não foi possível calcular agora. Você também pode consultar o frete na sacola.';
        }
      })
      .then(function () {
        if (!lineKey) return null;
        return post('/cart/change.js', { id: lineKey, quantity: qtyBefore }).catch(function () {});
      })
      .then(function () {
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  }

  function init(root) {
    if (root.dataset.ptdReady) return;
    root.dataset.ptdReady = '1';
    var input = root.querySelector('.ptd__cep');
    var button = root.querySelector('.ptd__calc');
    if (!input || !button) return;

    input.addEventListener('input', function () {
      var v = input.value.replace(/\D/g, '').slice(0, 8);
      input.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        calculate(root);
      }
    });
    button.addEventListener('click', function (e) {
      e.preventDefault();
      calculate(root);
    });
  }

  function boot() {
    document.querySelectorAll('[data-ptd]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
